module.exports = __webpack_public_path__ + "img/dog4.eb568ef7.png";